import React from "react";
import cx from "clsx";
import styles from "../../scss/Content.module.scss";
import classesResponsive from "../../../Shared/scss/Responsive.module.scss";
import Button from "../../../Shared/Button";
import { Link } from "react-router-dom";

const FirstSection = () => {
  return (
    <div className={styles.firstSection}>
      <div
        className={cx(
          styles.firstSectionLayout,
          classesResponsive.paddingLeftRight
        )}
      >
        <div className={styles.textContainer}>
          <div>
            <h1>
              Noi avem <span>grijă</span>
            </h1>
            <h2>de zâmbetul tău</h2>
          </div>
          <p>
            ArtDent oferă o gamă completă de servicii dentare atât pentru copii
            cât și pentru adulți.
          </p>
          <Button onClick={() => console.log("---")}><Link to="/programare">Fă o Programare</Link></Button>
        </div>
      </div>
    </div>
  );
};

export default FirstSection;
